// utmSlice.js
import { createSlice } from '@reduxjs/toolkit';

const utmSlice = createSlice({
  name: 'utm',
  initialState: { source: null },
  reducers: {
    setUTMSource: (state, action) => {
      state.source = action.payload;
    },
    clearUTMSource: (state) => {
      state.source = null;
    }
  }
});

export const { setUTMSource, clearUTMSource } = utmSlice.actions;
export default utmSlice.reducer;